exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selected-items {\n  margin-top: 10px;\n}\n\n.selected-item {\n  display: inline-block;\n  margin: 5px;\n  padding: 5px 10px;\n  background-color: #f0f0f0;\n  border-radius: 3px;\n}\n\n.selected-item span {\n  margin-right: 10px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/modules/export/components/target-group-analytics/target-group-analytics.component.css
// module id = ../../../../../src/app/modules/export/components/target-group-analytics/target-group-analytics.component.css
// module chunks = main